import { t } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/_unterschriftdokumente')({
  component: RouteComponent,

  loader: () => ({
    breadcrumb: {
      label: t`Unterschriftdokumente`,
      to: '/patienten/$id/unterschriftsdokumente',
      params: { id: 'patientId' },
    },
  }),
})

function RouteComponent() {
  return <Outlet />
}
